// extracted by mini-css-extract-plugin
export default {"varriant2":"PatientSuperSearchInput_varriant2__y64RN","varriant1_input2":"PatientSuperSearchInput_varriant1_input2__EQFi+"};